module.exports = __webpack_public_path__ + "static/media/002-tongue-depressor-orange.893babe6.svg";